/*
 * Copyright Reiryoku Technologies and its contributors, www.reiryoku.com, www.mida.org
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
*/

import { MidaTradingPlatform, } from "@reiryoku/mida";
import { CTraderAccount, } from "#platforms/ctrader/CTraderAccount";
import { CTraderLoginParameters, } from "#platforms/ctrader/CTraderLoginParameters";
import { CTraderApplication, } from "#platforms/ctrader/CTraderApplication";

const loggedAccounts: Map<string, CTraderAccount> = new Map();

export class CTrader extends MidaTradingPlatform {
    public constructor () {
        super({ name: "cTrader", siteUri: "https://ctrader.com", });
    }

    public async login ({
        clientId,
        clientSecret,
        demoProxy,
        liveProxy,
        accessToken,
        cTraderBrokerAccountId,
    }: CTraderLoginParameters): Promise<CTraderAccount> {
        if (loggedAccounts.has(cTraderBrokerAccountId)) {
            return loggedAccounts.get(cTraderBrokerAccountId) as CTraderAccount;
        }

        const cTraderApplication: CTraderApplication = await CTraderApplication.create({
            clientId,
            clientSecret,
            demoProxy: demoProxy ?? "demo.ctraderapi.com",
            liveProxy: liveProxy ?? "live.ctraderapi.com",
        });

        const tradingAccount: CTraderAccount = await cTraderApplication.loginTradingAccount(accessToken, cTraderBrokerAccountId);

        await tradingAccount.preload();

        loggedAccounts.set(cTraderBrokerAccountId, tradingAccount);

        return tradingAccount;
    }
}
